export const ENTITY_TYPE_OPTIONS = ['all', 'songs', 'artists', 'albums'];